import BONESMidwayJavaScriptClient from "BONESMidwayJavaScriptClient";

export class JSClient {

  constructor(props) {
    this.props = props || {};
    this.clientLoaded = this.clientLoaded.bind(this);
    this.getTestCases = this.getTestCases.bind(this);
    this.postTestCase = this.postTestCase.bind(this);
    this.client = new BONESMidwayJavaScriptClient();
    new BONESMidwayJavaScriptClient({ onReady: this.clientLoaded });
  }

  clientLoaded(client) {
    this.client = client;
    if (this.props.hasOwnProperty("onReady")) {
      this.props.onReady();
    }
  }

  getTestCases(request) {
    let url = "/test?";
    Object.keys(request).forEach(key => url += `${key}=${request[key]}&`);
    console.log(url);
    return this.client.get(url);
  }

  postTestCase(request) {
    return this.client.post("/test", request);
  }
}


// WEBPACK FOOTER //
// ./src/components/JSClient.jsx